
import { Component, Vue } from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';
import VWidget from '@/components/VWidget.vue';
import Ajax from '@/lib/ajax';

@Component({ components: { apexcharts: VueApexCharts, VWidget } })
export default class CampaignDashboardView extends Vue {
    loading = false;
    dealers: any[] = [];
    filters: any = { date_from: null, date_to: null, dealer_ids: [] };
    kpis: any = { total: 0, worked: 0, pending: 0 };

    get cards(): any[] {
        return [
            { label: 'Total campañas', value: this.kpis.total, caption: 'VINs de todas las campañas', icon: 'notifications_none', color: 'primary' },
            { label: 'Campañas trabajadas', value: this.kpis.worked, caption: 'VINs revisados', icon: 'check_circle_outline', color: 'success' },
            { label: 'Campañas no trabajadas', value: this.kpis.pending, caption: 'VINs pendientes de revisión', icon: 'hourglass_empty', color: 'grey' },
        ];
    }

    get chartSeries(): number[] { return [this.kpis.worked, this.kpis.pending]; }
    get chartOptions(): any {
        return {
            labels: ['VINs trabajados', 'VINs no trabajados'],
            colors: ['#26a69a', '#bdbdbd'],
            legend: { position: 'right' },
            dataLabels: { formatter: (value: number) => `${Math.round(value)}%` },
            responsive: [{ breakpoint: 600, options: { legend: { position: 'bottom' } } }],
        };
    }

    async created() { await this.load(); }

    async load() {
        this.loading = true;
        try {
            const params: any = {};
            if (this.filters.date_from) params.date_from = this.filters.date_from;
            if (this.filters.date_to) params.date_to = this.filters.date_to;
            if (this.filters.dealer_ids.length) params.dealer_ids = this.filters.dealer_ids;
            const response = await Ajax.get('/api/campaign-dashboard', { params });
            const result = response.data.result;
            this.kpis = result.kpis;
            this.dealers = result.dealers.map((dealer: any) => ({
                ...dealer,
                display_name: `${dealer.name || dealer.business_name}${dealer.location ? ' - ' + dealer.location : ''}`,
            }));
        } finally { this.loading = false; }
    }
}
